/** @format */

import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchBrokerObjectsService } from 'services/apiService';
import * as actionTypes from 'stateContainer/action-types';
import { push } from 'connected-react-router';

function* workerSaga({ payload }) {
  try {
    const response = yield call(fetchBrokerObjectsService, payload);
    if (response.data.status == 'success') {
      yield put({
        type: actionTypes.BROKER_OBJECTS_SUCCESS,
        payload: response.data
      });
    } else {
      throw new Error('Fetch broker objects failed');
    }
  } catch (error) {
    yield put({ type: actionTypes.BROKER_OBJECTS_ERROR, error });
    if (error.response.data.error == 'NotAuthorized') {
      yield put(push({ type: actionTypes.LOGOUT_REQUESTED }));
      yield put(push('/'));
    }
  }
}

export function* brokerObjectsSaga() {
  yield takeLatest(actionTypes.BROKER_OBJECTS_REQUESTED, workerSaga);
}
